import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const circleButtonStyle = css`
  border-radius: 50%;
  line-height: 40px;
  padding: 0;
  text-align: center;
  width: 40px;
`;

const StyledButton = styled.button`
  color: ${props =>
    props.bordered && !props.inverse ? props.theme.main : props.theme.white};
  background-color: ${props =>
    props.bordered
      ? 'transparent'
      : props.inverse
        ? props.theme.white
        : props.theme.main};
  border-color: ${props =>
    props.inverse ? props.theme.white : props.theme.main};
  border-style: solid;
  border-width: ${props => (props.bordered ? '3px' : '1px')};
  cursor: pointer;
  display: inline-block;
  font-size: ${props => (props.small ? '1rem' : '1.5rem')};
  padding: ${props => (props.small ? '.5rem 1rem' : '1rem 2rem')};
  text-decoration: none;
  text-transform: uppercase;
  transition-duration: 0.5s;
  transition-property: background-color, color;
  ${props => (props.circle ? circleButtonStyle : '')};

  &:hover,
  &:focus {
    background-color: ${props => props.theme.main};
    border-color: ${props => props.theme.main};
    color: ${props => props.theme.white};
    opacity: 0.95;
  }
`;

const Link = StyledButton.withComponent('a');

let Button = ({ children, link, ...otherProps }) =>
  link ? (
    <Link {...otherProps}>{children}</Link>
  ) : (
    <StyledButton {...otherProps}>{children}</StyledButton>
  );

Button.propTypes = {
  children: PropTypes.node.isRequired
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js